import { InjectionToken } from '@angular/core';
import { PinnaklEnvironment } from './environment.model';

export const ENVIRONMENT = new InjectionToken<PinnaklEnvironment>('EnvironmentConfig');
